import { useLang } from 'hooks/lang';

import { calculateProjectTotal, calculateProjectCountryTotal } from 'entities';

import { Column, Row } from 'components/Blocks';

import { formatCurrency } from 'utils/text';
import { getCountryLabel } from 'utils/countries';

import { StepComponentProps } from '../types';

export function Total({ state }: Pick<StepComponentProps, 'state'>) {
  const { t } = useLang();

  if (!state.countries.length) return null;

  return (
    <Column>
      <hr />

      <h6 className="my-2">{t('total')}</h6>

      {state.countries.map((country) => (
        <Row key={country} justifyContent="space-between" fullWidth>
          <span className="font-semibold">{getCountryLabel(country)}</span>

          <div className="flex-1 border-t border-dashed" />

          <span className="font-medium">
            {formatCurrency(calculateProjectCountryTotal(state.services, country), state.currency)}
          </span>
        </Row>
      ))}

      <Row justifyContent="space-between" fullWidth>
        <span className="text-lg font-semibold text-primary">{t('total')}</span>

        <div className="flex-1 border-t border-dashed" />

        <span className="text-xl font-bold text-primary">
          {formatCurrency(calculateProjectTotal(state.services), state.currency)}
        </span>
      </Row>
    </Column>
  );
}
